import React from "react";

import { calculateTotalCost, calculateMaxEstimatedCost } from "ComparePlans/calculateCost";
import EligibilityBadge from "ComparePlans/Components/Badge";
import SBCLinkCell from "ComparePlans/Components/SBCLinkCell";
import isIntuit from "Intuit/isIntuit";
import formatCurrency from "Utils/formatCurrency";

import { DetailHeader, DetailContent } from "./DetailRows";

import type { MedicalPlanPrice } from "Utils/types";

type Props = {
  plans: Array<MedicalPlanPrice>;
  isInRenewal?: boolean;
};

export default function Overview({ plans, isInRenewal }: Props) {
  const content = [];

  plans.forEach((plan) => {
    const planContent = [];
    if (isIntuit()) {
      planContent.push(DetailHeader("Total Cost"));
      planContent.push(DetailContent([formatCurrency(plan.average_monthly_premium), "/Month"]));
    } else {
      const totalCost = plan.employee_costs ? calculateTotalCost(plan) : plan.total_cost;
      planContent.push(DetailHeader("Total Cost"));
      planContent.push(DetailContent([formatCurrency(totalCost, 0), "/Month"]));

      planContent.push(DetailHeader("Employee Average"));
      planContent.push(DetailContent([formatCurrency(plan.average_monthly_premium), "/Month"]));
    }

    planContent.push(DetailHeader("Deductible"));
    planContent.push(DetailContent(formatCurrency(plan.deductible)));

    planContent.push(DetailHeader("Annual Out-of-Pocket Limit"));
    planContent.push(DetailContent(formatCurrency(plan.limit)));

    planContent.push(DetailHeader("Plan Network"));
    planContent.push(DetailContent(plan.plan_type));

    planContent.push(DetailHeader("Estimated Doctor Visit"));
    planContent.push(DetailContent(formatCurrency(plan.estimated_costs.pcp_visit)));

    planContent.push(DetailHeader("Prescription Drugs"));
    planContent.push(DetailContent([formatCurrency(plan.estimated_costs.generic_drugs), formatCurrency(plan.estimated_costs.brand_drugs)].join(" - ")));

    planContent.push(DetailHeader("Estimated Hospitalization"));
    planContent.push(DetailContent(formatCurrency(calculateMaxEstimatedCost(plan, "hospitalization"))));

    planContent.push(DetailHeader("Summary of Benefits"));
    planContent.push(DetailContent(<SBCLinkCell plan={plan} />));

    if (isInRenewal) {
      planContent.push(DetailHeader("Eligibility"));
      planContent.push(DetailContent(<EligibilityBadge plan={plan} />));
    }

    content.push(planContent);
  });

  return content;
}
